import { useSelector } from 'react-redux'

import { createStructuredSelector } from 'reselect'

import {
  selectDocType,
  selectCustomerFullName,
  selectDocId,
  selectNationality,
  selectBirthDate,
  selectContactPhone,
  selectSegmentLiteral,
  selectIsCompanyCustomerSegment,
  selectCIF,
  selectCompanyName,
  selectGender,
} from '../../store/customer.selectors'

import { RootState } from '~/core/store/root.reducer'

interface CustomerSummaryStore {
  docType: string
  docId: string
  fullName: string
  nationality: string
  birthdate?: string
  contactPhone?: string
  segment: string
  isCompany: boolean
  cif?: string
  companyName?: string
  gender?: string
}

const customerSelectors = createStructuredSelector<RootState, CustomerSummaryStore>({
  docType: selectDocType,
  fullName: selectCustomerFullName,
  docId: selectDocId,
  nationality: selectNationality,
  birthdate: selectBirthDate,
  contactPhone: selectContactPhone,
  segment: selectSegmentLiteral,
  isCompany: selectIsCompanyCustomerSegment,
  cif: selectCIF,
  companyName: selectCompanyName,
  gender: selectGender,
})

export default function useCustomerSummary() {
  const customer = useSelector(customerSelectors)

  return { ...customer }
}
